import React from 'react'

import { routes } from 'src/constants/routes'
import OmniSearchHeader from 'client/components/OmniSearchHeader'
import { useSearch } from 'src/hooks/useSearch'

const pageId = routes.landings.page

const LandingsHeader = () => {
  const { oldSearchUrl } = useSearch()

  return (
    <OmniSearchHeader
      pageId={pageId}
      bottom={null}
      fixed
      preventNavigation={false}
      searchUrl={oldSearchUrl}
    />
  )
}

export default LandingsHeader
